/* eslint-disable camelcase */
import React from "react";
import min from "lodash/minBy";
import max from "lodash/maxBy";
import { d3, gettext, cropr } from "../../adapter";
import moment from "moment";

const WeatherDataAverages = ({ station, domain }) => {
  var from = domain[0];
  var to = domain[1];

  // etnul should be based on day data
  var d = new Date();
  var offset = d.getTimezoneOffset() * 1000 * 60;
  var measurements_day = station.day_measurements.filter(function (el) {
    var d = new Date(el.timestamp * 1000 + offset);
    return d >= from && d <= to;
  });

  var ettot = 0.0;
  for (var i = 0; i < measurements_day.length; i++) {
    ettot += measurements_day[i].values.et_nul;
  }

  var measurements = station.measurements;
  var precipitationInDomain = measurements.precipitation.filter(function (el) {
    return el.timestamp >= from && el.timestamp <= to;
  });

  var precipitationSum = d3.sum(precipitationInDomain, function (d) {
    return d.y;
  });

  var radiationInDomain = measurements.radiation.filter(function (el) {
    return el.timestamp >= from && el.timestamp <= to;
  });

  var radiationSum = d3.sum(radiationInDomain, function (d) {
    return d.y;
  });

  var airTemperatureInDomain = measurements.airTemperature.filter(function (el) {
    return el.timestamp >= from && el.timestamp <= to;
  });

  var airTemperatureMean =
    d3.mean(airTemperatureInDomain, function (d) {
      return d.y;
    }) || null;
  var airTemperatureMin = min(airTemperatureInDomain, function (d) {
    return d.y;
  });
  var airTemperatureMax = max(airTemperatureInDomain, function (d) {
    return d.y;
  });

  var windSpeedInDomain = measurements.windSpeed.filter(function (el) {
    return el.timestamp >= from && el.timestamp <= to;
  });

  var windSpeedMean =
    d3.mean(windSpeedInDomain, function (d) {
      return d.y;
    }) || null;
  var windSpeedMax = max(windSpeedInDomain, function (d) {
    return d.y;
  });

  var relativeHumidityInDomain = measurements.relativeHumidity.filter(function (el) {
    return el.timestamp >= from && el.timestamp <= to;
  });

  var relativeHumidityMin = min(relativeHumidityInDomain, function (d) {
    return d.y;
  });
  var relativeHumidityMax = max(relativeHumidityInDomain, function (d) {
    return d.y;
  });
  var dokoozlian = 0;
  var dokoozlian7 = 0;
  var dokoozlian20 = 0;
  var dokfrom = new Date(to.getFullYear(), 4, 1, 0, 0, 0);
  var dokto = new Date(to.getFullYear(), 5, 15, 23, 0, 0);

  var dokoozlianInDomain = measurements.airTemperature.filter(function (el) {
    return el.timestamp >= dokfrom && el.timestamp <= dokto;
  });
  for (i = 0; i < dokoozlianInDomain.length; i++) {
    if (dokoozlianInDomain[i].y < 7.0) {
      dokoozlian7++;
    } else if (dokoozlianInDomain[i].y > 20.0) {
      dokoozlian20++;
    }
  }
  if (dokoozlian20 > 0) dokoozlian = dokoozlian7 / dokoozlian20;

  var ettext = "";
  if (ettot > 0.01) {
    ettext = (
      <div>
        <dt>{gettext("ET0 sum")}:</dt>
        <dd>
          {ettot < 0.01
            ? gettext("No data")
            : cropr.toLocaleFixed(ettot, 1) + " " + cropr.l10n.unit_precipitation_display}
        </dd>
      </div>
    );
  }

  var dokoozliantext = "";
  if (dokoozlian > 0 && station.chill === true) {
    dokoozliantext = (
      <dl className="is-wider has-large-spacing">
        <dt>Dakoozlian chill units:</dt>
        <dd>{cropr.toLocaleFixed(dokoozlian, 2)}</dd>
      </dl>
    );
  }

  return (
    <div>
      <dl className="is-wider has-large-spacing">
        <dt>{gettext("Precipitation sum")}:</dt>
        <dd>
          {precipitationSum === null
            ? gettext("Precipitation sum")
            : cropr.toLocaleFixed(precipitationSum, 1) +
              " " +
              cropr.l10n.unit_precipitation_display}
        </dd>
        <dt>{gettext("Radiation sum")}:</dt>
        <dd>
          {radiationSum === null
            ? gettext("No data")
            : cropr.toLocaleFixed(radiationSum, 1, true) + " " + gettext("J/cm\u00b2")}
        </dd>
        {ettext}
      </dl>
      <dl className="is-wider has-large-spacing">
        <dt>{gettext("Avg. air temperature")}:</dt>
        <dd>
          {airTemperatureMean === null
            ? gettext("No data")
            : cropr.toLocaleFixed(airTemperatureMean, 1) + " " + cropr.l10n.unit_temp_display}
        </dd>
        <dt>{gettext("Min. air temperature")}:</dt>
        <dd>
          {airTemperatureMin === undefined || airTemperatureMin === Number.POSITIVE_INFINITY
            ? gettext("No data")
            : cropr.toLocaleFixed(airTemperatureMin.y, 1) +
              " " +
              cropr.l10n.unit_temp_display +
              " " +
              gettext("at") +
              " " +
              moment(airTemperatureMin.timestamp).format("LLL")}
        </dd>
        <dt>{gettext("Max. air temperature")}:</dt>
        <dd>
          {airTemperatureMax === undefined || airTemperatureMax === Number.NEGATIVE_INFINITY
            ? gettext("No data")
            : cropr.toLocaleFixed(airTemperatureMax.y, 1) +
              " " +
              cropr.l10n.unit_temp_display +
              " " +
              gettext("at") +
              " " +
              moment(airTemperatureMax.timestamp).format("LLL")}
        </dd>
      </dl>
      <dl className="is-wider has-large-spacing">
        <dt>{gettext("Avg. wind speed")}:</dt>
        <dd>
          {windSpeedMean === null
            ? gettext("No data")
            : cropr.toLocaleFixed(windSpeedMean, 1) + " " + cropr.l10n.unit_windspeed_display}
        </dd>
        <dt>{gettext("Max. wind speed")}:</dt>
        <dd>
          {windSpeedMax === undefined || windSpeedMax === Number.NEGATIVE_INFINITY
            ? gettext("No data")
            : cropr.toLocaleFixed(windSpeedMax.y, 1) +
              " " +
              cropr.l10n.unit_windspeed_display +
              " " +
              gettext("at") +
              " " +
              moment(windSpeedMax.timestamp).format("LLL")}{" "}
        </dd>
      </dl>
      <dl className="is-wider has-large-spacing">
        <dt>{gettext("Min. rel. humidity")}:</dt>
        <dd>
          {relativeHumidityMin === undefined || relativeHumidityMin === Number.POSITIVE_INFINITY
            ? gettext("No data")
            : cropr.toLocaleFixed(relativeHumidityMin.y, 0) +
              "% " +
              gettext("at") +
              " " +
              moment(relativeHumidityMin.timestamp).format("LLL")}
        </dd>
        <dt>{gettext("Max. rel. humidity")}:</dt>
        <dd>
          {relativeHumidityMax === undefined || relativeHumidityMax === Number.NEGATIVE_INFINITY
            ? gettext("No data")
            : cropr.toLocaleFixed(relativeHumidityMax.y, 0) +
              "% " +
              gettext("at") +
              " " +
              moment(relativeHumidityMax.timestamp).format("LLL")}
        </dd>
      </dl>
      {dokoozliantext}
    </div>
  );
};

export default WeatherDataAverages;
